<template>
  <vx-card :noShadow="true">
    <!-- :title="$t('Campaign’s Objective & Type')" -->
    <!-- :subtitle="$t('Campaign Card Subtitle')" -->
    <h5 class="custom-font-weight pt-4 font-medium"> {{ $t('Campaign’s Channel, Objective & Type') }} </h5>
    <!-- <h5 class="text-base font-normal text-gray-500 mt-2">
      {{ $t('Please fill in your campaign objective and type dates.') }}</h5> -->
    <div class="vx-row">
      <div class="vx-col w-full mt-16">
        <div class="flex justify-center">
          <h5 class="text-center font-hairline text-xl">
            {{ $t('Select your campaign channel') }}
          </h5>
          <speakol-tooltip class="campaign-objective-tooltip"
                           :tooltipRedirect="'https://speakol.zendesk.com/hc/en-us/articles/360016704040-Campaign-Objective'"
                           :tooltipAction="'Learn more here'"
                           :tooltipText="'To have a clear understanding, vision, and execution plan to what needs to be accomplished, you must define your goals and objectives.'">
          </speakol-tooltip>
        </div>
        <CardSlider
          @input="changeAdvertisingChannel"
          :value="value.advertisingChannel"
          :items="advertisingChannels"
          :soon_items="advertisingChannelsSoonItems"
          :beta_items="advertisingChannelsBetaItems"
          :disabled_items="!editing ? disabledAdvertisingChannels : advertisingChannels.map(i => i.title)" />
      </div>

      <div class="vx-col w-full mt-16">
        <div class="flex justify-center">
          <h5 class="text-center font-hairline text-xl">
            {{ $t('Select your campaign objective') }}
          </h5>
          <speakol-tooltip class="campaign-objective-tooltip"
            :tooltipRedirect="'https://speakol.zendesk.com/hc/en-us/articles/360016704040-Campaign-Objective'"
            :tooltipAction="'Learn more here'"
            :tooltipText="'To have a clear understanding, vision, and execution plan to what needs to be accomplished, you must define your goals and objectives.'">
          </speakol-tooltip>
        </div>
        <CardSlider
          @input="changeObjective"
          :value="value.objective"
          :items="filteredObjectives"
          :new_items="[this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM, this.$constants.CAMPAIGN_OBJECTIVES_NAMES.FACEBOOK_OUTCOME_CONVERSION_LEADS, this.$constants.CAMPAIGN_OBJECTIVES_NAMES.FACEBOOK_OUTCOME_CONVERSION_SALES]"
          :disabled_items="!editing ? [] : objectives.map(i => i.title)" />
      </div>

      <div class="vx-col w-full mt-12">
        <div class="flex justify-center">
          <h5 class="text-center font-hairline text-xl">
            {{ $t('Select your campaign type') }}
          </h5>
          <speakol-tooltip class="campaign-objective-tooltip"
            :tooltipRedirect="'https://speakol.zendesk.com/hc/en-us/articles/360016737999-Campaign-Type'"
            :tooltipAction="'Learn more here'"
            :tooltipText="'Speakol enables you to create various kinds of campaigns, including Recommendation ads, Inline ads, and Video ads.'">
          </speakol-tooltip>
        </div>

        <CardSlider
          @input="changeType"
          :value="value.type"
          :items="filteredDisplayTypes"
          :disabled_items="!editing ? disabledTypesBasedOnObjective : displayTypes.map(i => i.title)" />
      </div>
    </div>

    <vs-popup class="holamundo" :title="$t('Objective/Type Popup Confirmation Title')" :active.sync="OTPopup">
      <p class="mb-10">{{ $t('Objective/Type Popup Confirmation Message') }}</p>

      <div class="text-right">
        <vs-button id="create-campaign-s1-pop-up-close-button" class="mr-4" color="rgb(200, 200, 200)" textColor="#000" type="filled" @click="discardChanges()">
          {{ $t('Close') }}
        </vs-button>

        <vs-button id="create-campaign-s1-pop-up-confirm-button" color="primary" type="filled" @click="confirmChanges()">
          {{ $t('Confirm') }}
        </vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>


<script>
import CardSlider from '@/views/campaigns/components/CardSlider.vue'
import {mapGetters} from 'vuex'
import SpeakolTooltip from '@/components/speakol-template/SpeakolTooltip.vue'
import {constants as $constants} from '@/utils/Constants'

export default {
  props: {
    formData: {
      required: true,
      type: Object
    },
    value: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    CardSlider,
    SpeakolTooltip
  },
  watch: {
    targetingLookups (targetingLookups) {
      this.displayTypes = targetingLookups.display_types
      this.objectives = targetingLookups.objectives
      this.advertisingChannels = targetingLookups.advertising_channels

      if (!this.editing && this.displayTypes && this.objectives && this.advertisingChannels) {
        [this.value.advertisingChannelObject, this.value.advertising_channel_id, this.value.advertisingChannel] = [this.advertisingChannels[0], this.advertisingChannels[0].id, this.advertisingChannels[0].title];
        [this.value.type_id, this.value.type] = [this.displayTypes[0].id, this.displayTypes[0].title];
        [this.value.objective_id, this.value.objective] = [this.objectives[0].id, this.objectives[0].title]
      }
    },
    disabledTypesBasedOnObjective () {
      if (this.disabledTypesBasedOnObjective.includes(this.value.type)) {
        this.value.type = 'Recommendations'
      }
    },
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  data () {
    return {
      OTPopup: false,
      new_advertising_channel: '',
      new_objective: '',
      new_type: '',
      advertisingChannels: [],
      objectives: [],
      displayTypes: []
    }
  },
  computed: {
    $constants () {
      return $constants
    },
    ...mapGetters({
      targetingLookups: 'campaign/targetingLookups'
    }),

    disabledTypesBasedOnObjective () {
      let disabledItems = []

      if (
        [
          this.$constants.CAMPAIGN_OBJECTIVES_NAMES.CONVERSIONS,
          this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM
        ].includes(this.value.objective)
      ) {
        disabledItems = [
          this.$constants.CAMPAIGN_TYPES_NAMES.INLINE,
          this.$constants.CAMPAIGN_TYPES_NAMES.VIDEO
        ]
      }

      if (this.value.objective === this.$constants.CAMPAIGN_OBJECTIVES_NAMES.APP_INSTALLS) {
        disabledItems = [this.$constants.CAMPAIGN_TYPES_NAMES.INLINE]
      }

      return disabledItems
    },
    filteredObjectives () {
      const objectives = this.objectives.filter(obj => obj.advertising_channel_id === this.value.advertising_channel_id)

      if (!this.editing && objectives[0]) {
        [this.value.objective_id, this.value.objective] = [objectives[0].id, objectives[0].title]
      }
      return objectives
    },
    filteredDisplayTypes () {
      const displayedTypes = this.displayTypes.filter(obj => obj.advertising_channel_id === this.value.advertising_channel_id)

      if (!this.editing && displayedTypes[0]) {
        [this.value.type_id, this.value.type] = [displayedTypes[0].id, displayedTypes[0].title]
      }

      return displayedTypes
    },
    disabledAdvertisingChannels () {
      let disabledItems = []

      if (!this.$hasFeature(this.$constants.FEATURE_SHORTNAME.FACEBOOK_ADVERTISING_CHANNEL)) {
        disabledItems = [this.$constants.CAMPAIGN_ADVERTISING_CHANNELS_NAMES.FACEBOOK]
      }

      return disabledItems
    },
    advertisingChannelsBetaItems () {
      const newItems = []

      if (this.$hasFeature(this.$constants.FEATURE_SHORTNAME.FACEBOOK_ADVERTISING_CHANNEL)) {
        newItems.push(this.$constants.CAMPAIGN_ADVERTISING_CHANNELS_NAMES.FACEBOOK)
      }

      return newItems
    },
    advertisingChannelsSoonItems () {
      const soonItems = []

      if (!this.$hasFeature(this.$constants.FEATURE_SHORTNAME.FACEBOOK_ADVERTISING_CHANNEL)) {
        soonItems.push(this.$constants.CAMPAIGN_ADVERTISING_CHANNELS_NAMES.FACEBOOK)
      }

      return soonItems
    }
  },
  methods: {
    showModal () {
      this.OTPopup = true
    },
    changeAdvertisingChannel (value) {
      if (this.value.advertisingChannel === value) {
        return
      }

      if (this.isFormFilled()) {
        this.new_advertising_channel = value
        this.showModal()
        return
      }
      this.$gtag.event(`channel-${value}`)

      this.setAdvertisingChannelByTitle(value)
    },
    changeObjective (value) {
      // Set Type To The First Type (Recommendation)
      const displayedTypes = this.displayTypes.filter(obj => obj.advertising_channel_id === this.value.advertising_channel_id)

      this.value.type_id = displayedTypes[0].id

      if (this.value.objective === value) {
        return
      }

      if (this.isFormFilled()) {
        this.new_objective = value
        this.showModal()
        return
      }
      this.$gtag.event(`obj-${value}`)

      this.setObjectiveByTitle(value)
    },
    changeType (value) {
      if (this.value.type === value) {
        return
      }

      if (this.isFormFilled()) {
        this.new_type = value
        this.showModal()
        return
      }
      this.$gtag.event(`type-${value}`)
      this.setTypeByTitle(value)
    },
    confirmChanges () {
      // update the data
      if (this.new_advertising_channel !== '') {
        this.setAdvertisingChannelByTitle(this.new_advertising_channel)
      }

      if (this.new_objective !== '') {
        this.setObjectiveByTitle(this.new_objective)
      }

      if (this.new_type !== '') {
        this.setTypeByTitle(this.new_type)
      }

      // close the modal
      this.OTPopup = false

      this.$emit('reset-form')
    },
    discardChanges () {
      // close the modal
      this.OTPopup = false
    },
    isFormFilled () {
      return this.formData.step2.name !== '' || this.formData.step2.brand !== '' || this.formData.step2
        .industry_id !== null
    },
    setTypeByTitle (new_type) {
      const item = this.displayTypes.find(i => i.title === new_type)

      if (item) {
        this.value.type = item.title
        this.value.type_id = item.id
      }
    },
    setObjectiveByTitle (new_objective) {
      const item = this.objectives.find(i => i.title === new_objective)

      if (item) {
        this.value.objective = item.title
        this.value.objective_id = item.id
      }
    },
    setAdvertisingChannelByTitle (new_advertising_channel) {
      const item = this.advertisingChannels.find(i => i.title === new_advertising_channel)

      if (item) {
        this.value.advertisingChannelObject = item
        this.value.advertisingChannel = item.title
        this.value.advertising_channel_id = item.id
      }
    }
  }
}

</script>

<style lang="scss">
  .campaign-objective-tooltip {
    position: relative;
    top: -5px;
  }

  .custom-font-weight {
    font-weight: 500 !important;
  }

  @media (max-width: 640px) {
    .custom-font-weight {
      font-size: 14.96px;
      margin-bottom: 10px;
    }

    [dir=ltr] .card-carousel--nav__right[data-v-9d306b86] {
      right: 20px;
    }

    [dir=ltr] .card-carousel--nav__left[data-v-9d306b86] {
      left: 13px;
    }

    .card-carousel--card--footer {
      height: 270px;
      width: 250px;
    }

    .demo-alignment > * {
      margin: 0 auto;
    }
  }

</style>
